import React from 'react';
import { useEditGroup } from 'src/components/People/Groups/hooks/useEditGroup';
import { ManageGroupForm } from 'src/components/People/Groups/ManageGroupForm';
import { IGroup } from 'src/utilities/useSearchHooks';

interface IEditGroupFormProps {
  corpId: string;
  groupInfo: IGroup;
  onSuccess: () => void;
  onCancel: () => void;
}

export const EditGroupForm: React.FC<IEditGroupFormProps> = ({
  corpId,
  groupInfo,
  onSuccess,
  onCancel,
}) => {
  const { mutate } = useEditGroup({ onSuccess });

  return (
    <ManageGroupForm
      groupDataToEdit={groupInfo}
      onSubmit={(groupFields) =>
        mutate({ ...groupFields, id: groupInfo.id }, corpId)
      }
      onCancel={onCancel}
    />
  );
};
